import { IoIosInformationCircle } from "react-icons/io";
import { toDateTime } from "../../../../../../Services/string.service";

const SpeedCell = ({ props }) => {
  const style = {
    fontWeight: ["1", "2", "3", "4"].includes(props.speedStatus) ? "bold" : "normal",
    color:
      props.speedStatus === "1" || props.speedStatus === "2"
        ? "red"
        : props.speedStatus === "3" || props.speedStatus === "4"
        ? "orange"
        : "inherit",
    fontSize: "13px",
  };

  const label = <span className="d-inline-block" style={style}>{props.speed?.toFixed(2)} Km/h</span>;

  if (!props.speedStatusDescription) return label;

  return (
    <div title={props.speedStatusDescription} style={{ cursor: "help" }}>
      {label}
    </div>
  );
};

const IgnitionCell = ({ props, vehicleId }) => {
  const src =
    props.ignition === "Ligado"
      ? "/images/icons/opened.png"
      : props.ignition === "Desligado"
      ? "/images/icons/closed.png"
      : null;

  if (!src) return <div style={{ width: "100px", paddingLeft: "13px" }}>{props.ignition}</div>;

  return (
    <div title={props.ignition} style={{ width: "100px", paddingLeft: "13px", cursor: "help" }}>
      <img src={src} alt={props.ignition} style={{ width: "24px" }} />
    </div>
  );
};

const LevelEventCell = ({ props, layoutMode }) => {
  if (props.levelEvent === "") return null;

  const eventColor =
    props.levelEvent === "1" ? "red"
    : props.levelEvent === "2" ? "orange"
    : props.levelEvent === "3" ? "blue"
    : "inherit";

  if (layoutMode === "grid-only") {
    return <span style={{ color: eventColor, fontSize: "13px" }}>{props.event}</span>;
  }

  return (
    <div style={{ width: "100px", paddingLeft: "6px", display: "flex", alignItems: "center", gap: 20 }}>
      <div title={props.event} style={{ cursor: "help" }}>
        <IoIosInformationCircle style={{ color: eventColor }} size={18} />
      </div>
    </div>
  );
};

const LocationCell = ({ props, vehicleId }) => {
  const mapsUrl = props.location
    ? `https://www.google.com/maps?q=${encodeURIComponent(props.location)}`
    : null;

  return (
    <div>
      {mapsUrl ? (
        <a
          href={mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={-1}
          onFocus={(e) => e.stopPropagation()}
        >
          {props.location}
        </a>
      ) : (
        <span>{props.location}</span>
      )}
    </div>
  );
};

const VehicleIdCell = ({ props }) => {
  if (!props.latitude || !props.longitude) {
    return <div className="action-table-col" style={{ width: "40px", paddingLeft: "30px" }} />;
  }

  return (
    <div className="action-table-col" style={{ width: "50px", paddingLeft: "25px" }}>
      <a
        href={`https://www.google.com/maps?q=${props.latitude},${props.longitude}`}
        target="_blank"
        rel="noopener noreferrer"
        title="Abrir no Google Maps"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Google_Maps_icon_%282015-2020%29.svg/2048px-Google_Maps_icon_%282015-2020%29.svg.png"
          width={25}
          height={25}
          alt="mapa"
        />
      </a>
    </div>
  );
};

export const createFieldRenderer =
  ({ vehicleId, layoutMode, onDateClick }) =>
  (field) =>
  (props) => {
    if (field === "generationDate") {
      return (
        <span
          onClick={() => onDateClick(props.latitude, props.longitude)}
          style={{ fontSize: "13px", cursor: "pointer" }}
        >
          {toDateTime(props[field])}
        </span>
      );
    }

    if (field === "statusDescription") {
      return (
        <div
          title={props.statusDescription}
          style={{
            backgroundColor: props.statusColor,
            width: 15,
            height: 15,
            marginLeft: "12px",
            cursor: "help",
          }}
        />
      );
    }

    if (field === "ignition") return <IgnitionCell props={props} vehicleId={vehicleId} />;
    if (field === "speed") return <SpeedCell props={props} />;
    if (field === "location") return <LocationCell props={props} vehicleId={vehicleId} />;
    if (field === "vehicleId") return <VehicleIdCell props={props} />;
    if (field === "levelEvent") return <LevelEventCell props={props} layoutMode={layoutMode} />;

    return <span>{props[field]}</span>;
  };
